import { render } from "./Assets.vue?vue&type=template&id=be06b448&scoped=true&lang=pug"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=be06b448&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be06b448"]])

export default __exports__